import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginComponent} from './login.component';
import {routing} from './login.routing';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {loginService} from './login.service';
import {ChangeLanguageModule} from '../shared/change-language/change-language.module';
import {SharedTranslationModule} from '../shared/change-language/shared-translation.module';
import {MstDepartmentService} from '../configuration/mst-department/mst-department.service';
import {MstUnitService} from '../configuration/mst-unit/mst-unit.service';
import {MstCashCounterService} from '../configuration/mst-cash-counter/mst-cash-counter.service';
import {Ng4LoadingSpinnerModule} from 'ng4-loading-spinner';
import {MstStaffService} from '../configuration/mst-staff/mst-staff.service';

@NgModule({
    imports: [
        CommonModule,
        routing,
        FormsModule,
        HttpModule,
        ReactiveFormsModule, SharedTranslationModule, ChangeLanguageModule,
        Ng4LoadingSpinnerModule
    ],
    declarations: [LoginComponent],
    providers: [loginService, MstDepartmentService, MstUnitService, MstCashCounterService, MstStaffService]
})
export class LoginModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/login/login.module.ts